import { Star, ArrowUpRight } from "lucide-react";
import { COMPANY_REVIEWS } from "@shared/companyFacts";

export default function SocialProof({
  variant = "default",
}: {
  variant?: "default" | "compact";
}) {
  return (
    <section
      className={
        variant === "compact" ? "bg-sand/50 py-6" : "bg-sand/50 py-12 sm:py-16"
      }
      aria-label="Kundomdömen"
    >
      <div className="container max-w-5xl flex flex-col sm:flex-row sm:items-center justify-between gap-5">
        <div>
          <p className="text-sm font-semibold text-navy mb-2">
            Kundernas omdömen om Nordiska Inglasningar AB
          </p>
          <div className="flex items-center gap-2">
            <Star className="w-6 h-6 text-amber-600" aria-hidden="true" />
            <span className="text-2xl font-bold text-navy">
              {COMPANY_REVIEWS.ratingLabel}
            </span>
          </div>
          <p className="mt-2 text-base">
            {COMPANY_REVIEWS.countLabel}. Omdömena avser företagets
            inglasningsuppdrag.
          </p>
          {variant !== "compact" && (
            <p className="text-sm text-muted-foreground mt-2">
              Kontrollerat 21 september 2026. Betyg och antal kan ändras;
              aktuella uppgifter finns hos Reco.
            </p>
          )}
        </div>
        <a
          href={COMPANY_REVIEWS.sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-navy font-semibold underline underline-offset-4"
        >
          Läs omdömena hos Reco{" "}
          <ArrowUpRight aria-hidden="true" className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
}
